import request from '@/config/axios'

export interface AreaAgentNoticeItemVO {
  notifyEnabled?: boolean
  wxaEnabled?: boolean
  wxaTemplateTitle?: string
  page?: string
}

export interface AreaAgentNoticeConfigVO {
  become?: AreaAgentNoticeItemVO
  upgrade?: AreaAgentNoticeItemVO
  settle?: AreaAgentNoticeItemVO
  needArea?: AreaAgentNoticeItemVO
  withdraw?: AreaAgentNoticeItemVO
}

export interface AreaAgentConfigVO {
  id?: number
  open?: boolean
  selfBuy?: boolean
  becomeType?: number
  becomeCheck?: boolean
  becomeOrder?: number
  becomeOrderCount?: number
  becomeMoney?: number
  becomeGoodsIds?: string
  noregDesc?: string
  settleDays?: number
  payCharge?: number
  payBegin?: number
  payEnd?: number
  levelType?: number
  levelUrl?: string
  openMemberCenter?: boolean
  closeCommissionCenter?: boolean
  settleCycle?: number
  openProtocol?: boolean
  protocolContent?: string
  textsJson?: string
  centerDesc?: string
  noticeJson?: string
}

export const getAreaAgentConfig = async () => {
  return await request.get<AreaAgentConfigVO>({ url: '/trade/area-agent/config/get' })
}

export const saveAreaAgentConfig = async (data: AreaAgentConfigVO) => {
  return await request.put({ url: '/trade/area-agent/config/save', data })
}

export const getAreaAgentNotice = async () => {
  return await request.get<AreaAgentNoticeConfigVO>({ url: '/trade/area-agent/config/notice' })
}

export const saveAreaAgentNotice = async (data: AreaAgentNoticeConfigVO) => {
  return await request.put({ url: '/trade/area-agent/config/notice', data })
}
